export type DocumentStatus = 'complete' | 'pending' | 'incomplete' | 'deactivated';

export interface DocumentEntry {
  id: number;
  name: string;
  uploadDate: string;
  status: DocumentStatus;
  uploadedBy: string;
}

export interface DocumentApiEntry {
  id: number;
  document: string;
  upload_date: string;
  status: string;
  comments: string | null;
  file_path: string | null;
  uploaded_by: string | null;
}

export interface DocumentDownloadResponse {
  download_url: string;
  expires_in: number;
  filename: string;
  file_size: number;
  document_type: string;
  upload_date: string;
}

export interface DocumentRepositoryPresignedTarget {
  presigned_post: {
    url: string;
    fields: Record<string, string>;
  };
  s3_key: string;
  expires_in: number;
  max_file_size: number;
}

export interface DocumentRepositoryPresignedResponse {
  file: DocumentRepositoryPresignedTarget;
  contract: DocumentRepositoryPresignedTarget;
}

export interface DocumentRepositoryConfirmRequest {
  document_type: string;
  file_s3_key: string;
  contract_s3_key: string;
  selected_recipients: string;
}

export type DocumentRepositoryConfirmResponse = DocumentApiEntry;

export interface IgaCoordinatorContact {
  contact_name: string | null;
  email: string | null;
  status: string | null;
  last_signed: string | null;
  last_notified: string | null;
}

export interface LegalEntityContact {
  contact_name: string | null;
  legal_entity_name: string | null;
  country: string | null;
  email: string | null;
  status: string | null;
  last_signed: string | null;
  last_notified: string | null;
}

export interface ContactsApiResponse {
  document_type: string;
  contacts: {
    iga_coordinators: IgaCoordinatorContact[];
    legal_entity_contacts: LegalEntityContact[];
  };
}

export type RecipientGroup = 'iga_coordinators' | 'iga_coordinators_and_contacts';

export const RECIPIENT_GROUP_LABELS: Record<RecipientGroup, string> = {
  iga_coordinators: 'IGA Coordinators',
  iga_coordinators_and_contacts: 'IGA Coordinators and Document Contact List',
};
